import {List} from 'immutable';
export default List([
  {label: 'Exactly', value: 'EQUAL_TO'},
  {label: 'More Than', value: 'GREATER_THAN'},
  {label: 'Less Than', value: 'LESS_THAN'},
  {label: 'More Than or Equal To', value: 'GREATER_THAN_OR_EQUAL_TO'},
  {label: 'Less Than or Equal To', value: 'LESS_THAN_OR_EQUAL_TO'},
]);
